document.addEventListener("DOMContentLoaded", () => {
    initCollectionTabs();
    initSortDropdown();
    // initStickyFilters();
    // initCategorySlider();
    // initQuickView();
});

function initCollectionTabs() {
    const buttons = document.querySelectorAll(".dl-tab-buttons button");
    const panels = document.querySelectorAll(".tab-panel");

    if (!buttons.length) return;

    buttons.forEach(button => {
        button.addEventListener("click", () => {
            buttons.forEach(btn => btn.classList.remove("active"));
            panels.forEach(panel => panel.classList.remove("active"));

            button.classList.add("active");
            document
                .getElementById(button.dataset.tab)
                ?.classList.add("active");
        });
    });
}

function initSortDropdown() {

    const sort = document.querySelector("#SortBy");

    if (!sort) return;

    sort.addEventListener("change", function () {

        const url = new URL(window.location);

        url.searchParams.set("sort_by", this.value);

        window.location = url;

    });

}